import { render, staticRenderFns } from "./IconBellOut.vue?vue&type=template&id=df4ba3fe&"
import script from "./IconBellOut.vue?vue&type=script&lang=js&"
export * from "./IconBellOut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports